import { useEffect, useState } from 'react'
import { CustomButton } from 'modules/auth/styles'
import { DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Modal, ModalBody, ModalFooter } from 'reactstrap'
import { ModalForm, MoreButton, ReactSelectStyled } from 'modules/app/styles'
import { Field, Formik } from 'formik'
import * as yup from 'yup'
import { ButtonLoader, PageLoader } from 'utils/storageUtils'
import { ReactComponent as MenuIcon } from 'assets/images/icons/menu.svg'
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg'
import { connect } from 'react-redux'
import { MemberTabs } from 'modules/company/styles'
import { sendForgotPassword_api, changeOwnership_api, deleteCompanyMember_api, inviteUsers_api, removeInvitation_api, resendInvitation_api, updateCompanyMember_api } from 'store/apis'
import { handleApiError, logAmplitudeEvent } from 'utils/helpers'
import { toast } from 'react-toastify'
import { toggleInviteTeammates_action, getActiveSubscription_action, getCompany_action } from 'store/actions'
import { Active } from './Active'
import { Pending } from './Pending'
import { Removed } from './Removed'

export const getEmail = (member) => {
  if (member.user) {
    return member.user.email?.includes('.deleted') ? member.user.email.substring(0, member.user.email.indexOf('.deleted')) : member.user.email
  } else {
    return member.email?.includes('.deleted') ? member.email.substring(0, member.email.indexOf('.deleted')) : member.email
  }
}

export const MembersSetting = (props) => {
  const { company, getCompany, getActiveSubscription, is_loading, user } = props
  const [is_submitting, set_is_submitting] = useState(false)
  const [saved, set_saved] = useState(false)
  const [activeTab, set_activeTab] = useState('active')
  const [memberList, set_memberList] = useState([])
  const [editingMember, set_editingMember] = useState({})
  const [showEditMemberModal, set_showEditMemberModal] = useState(false)
  const [my_membership, set_my_membership] = useState({})
  const [new_owner, set_new_owner] = useState(null)
  const [new_owner_modal, set_new_owner_modal] = useState(false)
  const [showOwnerError, set_showOwnerError] = useState(false)
  const [is_changing, set_is_changing] = useState(false)
  const [_members, set_members] = useState([])
  const [hasError, set_hasError] = useState(false)

  const switchTab = (e) => {
    e.preventDefault()
    if (e.currentTarget === e.target) {
      set_activeTab(e.target.attributes['id'].value)
    } else {
      set_activeTab(e.target.closest('a').attributes['id'].value)
    }
  }
  useEffect(() => {
    if (company.id) {
      let members = []
      if (activeTab === 'active') {
        members = company.members.filter((m) => m.is_active && m.invite_status !== 'invited')
      } else if (activeTab === 'pending') {
        members = company.members.filter((m) => m.is_active && m.invite_status === 'invited')
      } else {
        members = company.members.filter((m) => !m.is_active)
      }
      set_memberList(members)
    }
  }, [activeTab, company])

  useEffect(() => {
    const i = memberList.map((m) => m.user_id).indexOf(user.id)
    if (i !== -1) {
      set_my_membership(memberList[i])
    }
  }, [memberList, user])

  // Edit Modal
  const onShowEditMember = (e, member) => {
    e.preventDefault()
    set_editingMember(member)
    set_showEditMemberModal(true)
  }
  const hideEditMember = () => {
    set_showEditMemberModal(false)
    set_editingMember({})
  }

  // Delete
  const onDeleteMember = async () => {
    if (window.confirm('Are you sure you want to remove this member?')) {
      try {
        await deleteCompanyMember_api(editingMember.member_code)
        logAmplitudeEvent('Member removed')
        toast.success('Member removed.')
        getCompany()
        getActiveSubscription()
        hideEditMember()
      } catch (error) {
        handleApiError(error)
      }
    }
  }
  // Reset
  const onResetPassword = async () => {
    try {
      await sendForgotPassword_api(editingMember.email)
      toast.success(`Password reset link sent to ${editingMember.email}`)
      setTimeout(() => {
        hideEditMember()
      }, 1500)
    } catch (error) {
      handleApiError(error)
    }
  }
  const onResendInvitation = async () => {
    try {
      await resendInvitation_api(editingMember.member_code)
      toast.success(`Invitation link sent to ${editingMember.email}`)
      setTimeout(() => {
        hideEditMember()
      }, 1500)
    } catch (error) {
      handleApiError(error)
    }
  }

  const onRemoveInvitation = async () => {
    try {
      await removeInvitation_api(editingMember.member_code)
      toast.success(`Invitation for ${editingMember.email} has been removed`)
      setTimeout(() => {
        hideEditMember()
      }, 1500)
    } catch (error) {
      handleApiError(error)
    }
  }

  useEffect(() => {
    set_members(memberList.filter((m) => m.is_active && m.invite_status === 'added'))
  }, [memberList])

  const onChangeOwnership = async (e, member) => {
    try {
      if (new_owner) {
        set_is_changing(true)
        const data = {
          _method: 'patch',
          new_owner_member_code: member.value
        }
        await changeOwnership_api(data)
        set_new_owner_modal(false)
        set_new_owner(null)
        getCompany()
      } else {
        set_hasError('Select member to transfer ownership')
      }
      set_is_changing(false)
      e.preventDefault()
    } catch (e) {
      handleApiError(e)
    }
  }

  return (
    <ModalBody>
      {is_loading && <PageLoader />}
      {!is_loading && company.id && (
        <ModalForm tag='div'>
          <div className='title d-flex justify-content-between'>
            Team Members
            <div className='d-flex align-items-center flex-wrap'>
              {my_membership.invite_status === 'owned' && _members.length > 0 && (
                <CustomButton onClick={() => set_new_owner_modal(true)} className='gray outlined btn-sm ml-auto my-auto mr-3 shadow-none'>
                  Change ownership
                </CustomButton>
              )}
              {my_membership.user_type === 'admin' && !props.subscription.cancel_at_period_end && (
                <CustomButton
                  className='black btn-sm my-auto px-5'
                  onClick={(e) => {
                    e.preventDefault()
                    props.toggleInviteTeammates(true)
                  }}>
                  Invite
                </CustomButton>
              )}
            </div>
          </div>
          <br />
          <MemberTabs>
            <a href='/' onClick={switchTab} id='active' className={`${activeTab === 'active' ? 'active' : ''}`}>
              Active <span className='small'>({company.members && company.members.filter((m) => m.is_active && m.invite_status !== 'invited').length})</span>
            </a>
            <a href='/' onClick={switchTab} id='pending' className={`${activeTab === 'pending' ? 'active' : ''}`}>
              Pending Invitations <span className='small'>({company.members && company.members.filter((m) => m.is_active && m.invite_status === 'invited').length})</span>
            </a>
            <a href='/' onClick={switchTab} id='inactive' className={`${activeTab === 'inactive' ? 'active' : ''}`}>
              Removed <span className='small'>({company.members && company.members.filter((m) => !m.is_active).length})</span>
            </a>
          </MemberTabs>

          {activeTab === 'active' && <Active user={user} my_membership={my_membership} memberList={memberList} onShowEditMember={onShowEditMember} />}
          {activeTab === 'pending' && <Pending user={user} my_membership={my_membership} memberList={memberList} onShowEditMember={onShowEditMember} />}
          {activeTab === 'inactive' && <Removed user={user} my_membership={my_membership} memberList={memberList} onShowEditMember={onShowEditMember} />}
        </ModalForm>
      )}

      {/* EDIT */}
      {showEditMemberModal && (
        <Modal isOpen centered fade={false} toggle={hideEditMember}>
          <Formik
            enableReinitialize
            initialValues={{
              member_code: editingMember.member_code || '',
              email: editingMember.email || '',
              user_type: editingMember.user_type || 'member'
            }}
            validationSchema={yup.object().shape({
              user_type: yup.string().required()
            })}
            onSubmit={async (values) => {
              try {
                set_is_submitting(true)
                if (values.member_code) {
                  const data = {
                    member_code: values.member_code,
                    user_type: values.user_type,
                    email: values.email
                  }
                  await updateCompanyMember_api(data)
                } else {
                  const data = { members: JSON.stringify([{ ...values }]) }
                  await inviteUsers_api(data)
                }
                set_saved(true)
                getCompany()
                setTimeout(() => {
                  set_saved(false)
                  hideEditMember()
                }, 1000)
              } catch (error) {
                handleApiError(error)
              }
              set_is_submitting(false)
            }}>
            {(formikProps) => (
              <ModalForm onSubmit={formikProps.handleSubmit} autoComplete='off'>
                <ModalBody>
                  <a
                    href='/'
                    className='modal-close'
                    onClick={(e) => {
                      e.preventDefault()
                      hideEditMember()
                    }}>
                    <CloseIcon />
                  </a>
                  <div className='title'> Edit Teammate </div>
                  <br />
                  <Field name='email'>
                    {({ field }) => (
                      <FormGroup>
                        <Input {...field} readOnly={editingMember.id} disabled={editingMember.id} className={`${formikProps.errors.email ? 'error' : ''} has-value`} />
                        <Label>Email</Label>
                      </FormGroup>
                    )}
                  </Field>
                  <FormGroup>
                    <Label>Role</Label>
                  </FormGroup>
                  <Field name='user_type'>
                    {({ field }) => (
                      <FormGroup check className='d-flex align-items-center px-0'>
                        <Label check className='mr-4'>
                          <Input type='radio' name='radio1' checked={field.value === 'admin'} value='admin' onChange={(e) => formikProps.setFieldValue('user_type', e.target.value)} />
                          <span>Admin</span>
                        </Label>
                        <Label check>
                          <Input type='radio' name='radio1' checked={field.value === 'member'} value='member' onChange={(e) => formikProps.setFieldValue('user_type', e.target.value)} />
                          <span>Member</span>
                        </Label>
                      </FormGroup>
                    )}
                  </Field>
                </ModalBody>
                <ModalFooter className='d-flex justify-content-center'>
                  {editingMember.id && (
                    <MoreButton direction='up'>
                      <DropdownToggle caret={false} tag='div'>
                        <CustomButton type='button' className='gray hover-black border shadow-none p-1'>
                          <MenuIcon style={{ width: 18, height: 18 }} />
                        </CustomButton>
                      </DropdownToggle>
                      <DropdownMenu className='horizontal-center'>
                        {editingMember.invite_status === 'invited' && (
                          <>
                            <DropdownItem className='py-2 border-bottom' onClick={onResendInvitation}>
                              Resend invitation
                            </DropdownItem>
                            <DropdownItem className='py-2 text-danger' onClick={onRemoveInvitation}>
                              Remove invitation
                            </DropdownItem>
                          </>
                        )}
                        {editingMember.invite_status !== 'invited' && editingMember.user && (
                          <>
                            <DropdownItem className='py-2 border-bottom' onClick={onResetPassword}>
                              Reset password
                            </DropdownItem>
                            {editingMember.invite_status !== 'owned' && (
                              <DropdownItem className='py-2 text-danger' onClick={onDeleteMember}>
                                Remove member
                              </DropdownItem>
                            )}
                          </>
                        )}
                      </DropdownMenu>
                    </MoreButton>
                  )}
                  <CustomButton type='submit' className={`mx-5 ${!saved ? 'black' : 'green'}`} disabled={is_submitting || saved}>
                    {saved ? 'Updated' : 'Update'} {is_submitting && <ButtonLoader />}
                  </CustomButton>
                  <a
                    href='/'
                    className='text-dark font-weight-600'
                    onClick={(e) => {
                      e.preventDefault()
                      hideEditMember()
                    }}>
                    Cancel
                  </a>
                </ModalFooter>
              </ModalForm>
            )}
          </Formik>
        </Modal>
      )}
      {new_owner_modal && (
        <Modal isOpen centered fade={false} toggle={() => set_new_owner_modal(false)}>
          <ModalForm onSubmit={(e) => e.preventDefault()} autoComplete='off'>
            <ModalBody>
              <div className='title'>Transfer Account Ownership</div>
              <p className='mb-4'>
                Select the user you want to transfer the account's ownership to. This action will make the selected user the admin of the account, with full permissions to all items and billing.
                <br />
              </p>
              <div className='d-flex align-items-center'>
                <div className={`font-weight-600 mr-3 ${showOwnerError && 'text-danger'}`}>Please select the new owner:</div>
                <div style={{ width: 200 }}>
                  <ReactSelectStyled
                    className='select-control'
                    classNamePrefix='select-control'
                    value={new_owner}
                    onChange={(obj) => {
                      set_showOwnerError(false)
                      set_new_owner(obj || null)
                    }}
                    options={_members.map((u) => ({ value: u.member_code, label: `${u.name} (${u.user_type})` }))}
                    placeholder=''
                  />
                </div>
              </div>
              {hasError && <div className='error-message w-100'> {hasError} </div>}
            </ModalBody>
            <ModalFooter>
              <CustomButton className='black' onClick={(e) => onChangeOwnership(e, new_owner)} disabled={is_changing}>
                Confirm {is_changing && <ButtonLoader />}
              </CustomButton>
              <CustomButton
                className='gray mr-3 shadow-none'
                onClick={() => {
                  set_showOwnerError(false)
                  set_new_owner({})
                  set_new_owner_modal(false)
                }}>
                Cancel
              </CustomButton>
            </ModalFooter>
          </ModalForm>
        </Modal>
      )}
    </ModalBody>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  company: state.company?.company
})

const mapDispatchToProps = (dispatch) => ({
  toggleInviteTeammates: (status) => dispatch(toggleInviteTeammates_action(status)),
  getCompany: () => dispatch(getCompany_action()),
  getActiveSubscription: () => dispatch(getActiveSubscription_action())
})

export default connect(mapStateToProps, mapDispatchToProps)(MembersSetting)
